import React from 'react';
import { Row, Col, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './BirthDateInfoModal.css';
import { isFromCallcenter } from '../../../services/queryService/QueryService';

import i18n from 'i18n-react';

const propTypes = {
    onClose: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    isCallcenterEnabled: PropTypes.bool
};

class BirthDateInfoModal extends React.Component {
    constructor(props) {
        super(props);
    
        this.state = {
          isCallcenterEnabled: props.isCallcenterEnabled || false,
        };
    }

    callCenterMode() {
        return this.state.isCallcenterEnabled && isFromCallcenter();
      }
    
    render() {
        return (
            <div>
                <Modal show={this.props.showModal}>
                    <div className="modalContainer bg-white padding-eight-56">
                        <Row>
                            <Col>
                                <h3 className="txtColorTitle txtAllingCenter">{i18n.translate('Atenção! \n')}</h3>
                                <div className="FlightInfo__hr bg-light-gray" />
                                <div className="padding-eight-bottom-6 textDescription">
                                    {this.props.isPassengerComarch ?                                    
                                    i18n.translate('components.passengerInfo.birthDateModal.msgBirthDate')
                                    :i18n.translate('components.passengerInfo.birthDateModal.msgBirthDateNotPassengerComarch')             
                                    }
                                </div>
                                <div className="padding-eight-bottom-48 textDescription">
                                    {i18n.translate('components.passengerInfo.birthDateModal.msgBirthDateInfo')}
                                </div>
                            </Col>
                            <Col>
                                <div className="flex">
                                    {
                                        <input
                                            placeholder="none"
                                            type="checkbox"
                                            className="FlightInfo__checkbox"
                                            onClick={() => this.props.onClose()}
                                        />
                                    }
                                    <div className="padding-eight-16 textInfoCheck">
                                        {this.callCenterMode() 
                                        ? i18n.translate('components.passengerInfo.birthDateModal.msgBirthDateCheckBoxCallCenter') 
                                        : i18n.translate('components.passengerInfo.birthDateModal.msgBirthDateCheckBox')}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Modal>
            </div>
        );
    }
}

BirthDateInfoModal.propType = propTypes;

export default BirthDateInfoModal;



// WEBPACK FOOTER //
// ./src/components/passengerInfo/birthDateInfoModal/BirthDateInfoModal.jsx